import { Button } from '@mui/material';
import axios from 'axios';
import { API_BASE_URL } from 'services/api';
import useAppStore from 'store/useAppStore';
import axios from 'axios';
const FilePreviewButton = ({ projectId, fileName, handleViewFile }) => {
  const company = useAppStore((state) => state.user.company);
  return (
    <Button
      className="ml-2"
      onClick={(e) => {
        e.stopPropagation();
        axios
          .post(
            // 'https://140.96.111.8:8516/api/getFileObject/',
            `${API_BASE_URL}/getFileObject/`,
            {
              comp_name: company,
              project_id: projectId,
              file_name: fileName,
            },
            {
              responseType: 'blob',
            },
          )
          .then(({ data }) => {
            handleViewFile(data);
          });
      }}
    >
      預覽
      {/* {!file ? '檔案不存在' : '預覽'} */}
    </Button>
  );
};

export default FilePreviewButton;
